import http from './http'
import config from '../common/config'
import { exportExcelWithCallBack } from './commonService'

/**
 * 通用API调用封装
 * @param {Function} httpMethod - http方法 (http.get/http.post等)
 * @param {string} url - API路径
 * @param {object} data - 请求参数
 * @param {object} options - 额外选项 {isFormData, isLoading, needXss, ifMultipart, isBlob}
 * @returns {Promise} 返回Promise
 */
const apiCall = (httpMethod, url, data, options = {}) => {
  const {
    isFormData = false,
    isLoading = false,
    needXss = true,
    ifMultipart = false,
    isBlob = false
  } = options

  if (httpMethod === http.get) {
    return httpMethod(url, data, isFormData, isLoading, isBlob)
  } else {
    return httpMethod(url, data, isFormData, isLoading, needXss, ifMultipart)
  }
}

/**
 * 会员加入
 */
export const memberJoin = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/memberJoin', data, {
    isLoading: true
  })
}

/**
 * C端会员更新
 */
export const cMemberUpdate = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/memberUpdate', data)
}

/**
 * B端添加会员
 */
export const memberAdd = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberB/memberAdd', data)
}

/**
 * 获取验证码接口
 */
export const getverificationUrl = (data) => {
  return apiCall(http.get, '/cas-member-manager/login/getVerificationCode', data, {
    isFormData: true,
    isBlob: true
  })
}

/**
 * C端会员更新并支付
 */
export const cMemberUpdateAndPay = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/memberUpdateAndPay', data)
}

/**
 * C端会员续费/升级（只需选择会员类型和级别，无需填写个人信息）
 */
export const cMemberRenew = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/memberRenew', data)
}
/**
 * 获取全部国家列表
 */
export const allCountry = (data) => {
  return apiCall(http.get, '/cas-member-manager/city/allRegion', data, {
    isFormData: true
  })
}

/**
 * 获取指定id下的城市/区域列表(不分页)
 */
export const getByPid = (data) => {
  return apiCall(http.get, '/cas-member-manager/city/getByPid', data, {
    isFormData: true
  })
}

/**
 * 获取RSA公钥
 */
export const getPublicKey = (data) => {
  return apiCall(http.get, '/cas-member-manager/publicKey/getPublicKey', data, {
    isFormData: true
  })
}
/**
 * 获取会员信息 C端认证
 */
export const getMemberInfo = (data) => {
  return apiCall(http.get, '/cas-member-manager/memberC/getMemberInfo', data, {
    isFormData: true
  })
}

/**
 * 会员登录 B+C共用非认证
 */
export const login = (data) => {
  return apiCall(http.post, '/cas-member-manager/login/login', data, {
    isLoading: true
  })
}

/**
 * 重置密码：C端专用未登录
 */
export const resetPassword = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/resetPasswordEmail', data)
}

/**
 * 修改密码：C端专用
 */
export const changePassword = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/resetPassword', data)
}

/**
 * 通过重置密码连接code(加密) 获取重置密码信息：C端专用未登录
 */
export const resetPasswordInfo = (data) => {
  return apiCall(http.post, '/cas-member-manager/memberC/resetPasswordInfo', data)
}

/**
 * 退出登录 B+C共用认证
 */
export const logout = (data) => {
  return apiCall(http.post, '/cas-member-manager/login/logout', data)
}
/**
 * 会议发起支付：已登录 C端认证
 */
export const conferenceStartPay = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceC/conferenceStartPay', data, {
    isLoading: true
  })
}

/**
 * 获取会员能够匹配的会议费用 C端已登录用户
 */
export const getConferenceAmountByMember = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceC/getConferenceAmountByMember', data, {
    isFormData: true
  })
}

/**
 * 获取会员的当前会议订单列表
 */
export const getMemberConferenceCurrent = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceC/getMemberConferenceCurrent', data, {
    isFormData: true
  })
}

/**
 * 获取会员的历史会议订单列表
 */
export const getMemberConferenceHistory = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceC/getMemberConferenceHistory', data, {
    isFormData: true
  })
}

/**
 * 获取会员等级列表
 */
export const getMemberLevelList = (data) => {
  return apiCall(http.get, '/cas-member-manager/memberLevel/getMemberLevelList', data, {
    isFormData: true
  })
}

/**
 * 获取捐赠选项列表
 */
export const getDonationOptionList = (data) => {
  return apiCall(http.get, '/cas-member-manager/donationOption/getDonationOptionList', data, {
    isFormData: true
  })
}

/**
 * 获取捐赠选项列表 B 认证
 */
export const getDonationBOptionList = (data) => {
  return apiCall(http.get, '/cas-member-manager/donationOptionB/getDonationOptionList', data, {
    isFormData: true
  })
}

/**
 * 新增捐赠选项 B 认证
 */
export const donationOptionAdd = (data) => {
  return apiCall(http.post, '/cas-member-manager/donationOptionB/donationOptionAdd', data)
}

/**
 * 修改当前会议费用内容 B 认证
 */
export const conferenceCurrentUpdateAmountContent = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceB/conferenceCurrentUpdateAmountContent', data)
}
// POST /conferenceB/conferenceCurrentUpdateSessionContent
// 修改 当前会议 会议主题投稿说明 B 认证
export const conferenceCurrentUpdateSessionContent = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceB/conferenceCurrentUpdateSessionContent',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /conference/getConferenceSessionContentByConferenceId
// 获取会议主题内容 C端已登录用户+游客共用接口 会议未找到&没配置都返回null
export const getConferenceSessionContentByConferenceIdC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceSessionContentByConferenceId',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 删除 捐赠选项 B 认证
export const donationOptionDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/donationOptionB/donationOptionDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /conferenceB/getConferenceSessionContentByConferenceId
// 获取 当前会议 主题内容 B端 认证：会议会找到报错
export const getConferenceSessionContentByConferenceId = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceB/getConferenceSessionContentByConferenceId',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取当前会议列表(根据最近排序): C端已登录用户+游客共用接口 根据会议开始时间正序排序
export const getConferenceCurrentList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceCurrentList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取当前会议列表（包含附加内容）: C端接口
export const getConferenceCurrentListWithContent = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceCurrentListWithContent',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export const getConferenceCurrentHomepageList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceCurrentHomepageList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /conference/getConferenceSessionByConferenceId
// 获取会议主题列表 C端已登录用户+游客共用接口 根据更新时间倒序排序
export const getConferenceSessionByConferenceId = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceSessionByConferenceId',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export const getConferenceCurrentDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceCurrentDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
export const getConferenceAmountByConferenceId = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceAmountByConferenceId',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员等级列表 B 认证
export const getMemberLevelBList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberLevelB/getMemberLevelList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员等级信息 B 认证
export const getMemberLeveB = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberLevelB/getMemberLeve',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 新增 会员等级 B 认证
export const memberLevelAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/memberLevelB/memberLevelAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改 会员等级 B 认证
export const memberLevelUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/memberLevelB/memberLevelUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 会员等级禁用/启用修改 B 认证
export const updateMemberLevelIsActive = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/memberLevelB/updateMemberLevelIsActive',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /memberConfig/getMemberConfigByType
// 获取会员配置信息：不包含vip C端 非认证 10:Join;20:Member Benefits;30:VIP
export const getMemberConfigByTypeC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberConfig/getMemberConfigByType',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /memberConfig/getMemberConfigByTypeNeedMember
// 获取会员 需要用户是会员的 例如vip C端 认证 10:Join;20:Member Benefits
export const getMemberConfigByTypeNeedMember = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberConfig/getMemberConfigByTypeNeedMember',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /homeC/getHomeCount
// 获取 首页数量 C端
export const getHomeCount = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/homeC/getHomeCount',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员权益 B端 认证: 10:Join;20:Member Benefits;30:VIP
export const getMemberConfigByType = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberConfigB/getMemberConfigByType',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员权益 B端 认证: 10:Join;20:Member Benefits;30:VIP
export const saveOrUpdateMemberConfigByType = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/memberConfigB/saveOrUpdateMemberConfigByType',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//导出会员列表 B端认证：比会员列表增加捐赠金额、总花费
export const exportMemberList = (reqParam) => {
    return new Promise((resolve, reject) => {
        exportExcelWithCallBack('/cas-member-manager/memberB/exportMemberList', reqParam, 'Member.xlsx').then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 获取会员统计数据 B端认证
export const getMemberStatistics = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberB/getMemberStatistics',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 导出有效会员列表 B端认证
export const exportValidMembers = (reqParam) => {
    return new Promise((resolve, reject) => {
        exportExcelWithCallBack('/cas-member-manager/memberB/exportValidMembers', reqParam, 'Valid_Members.xlsx').then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 获取会员等级列表 B 认证
export const getMemberBInfo = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberB/getMemberInfo',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员等级列表 B 认证
export const getMemberBList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/memberB/getMemberList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会员等级列表 B 认证
export const getMembershipTypeList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/membershipType/getMembershipTypeList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 会员禁用/启用修改,并让被修改用户退出登录：已登录 B端认证
export const updateMemberIsActive = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/memberB/updateMemberIsActive',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会议报名列表分页 B端 认证
export const getConferenceSignUpListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceSignUpB/getConferenceSignUpListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会议报名列表分页和所有总价数据 B端 认证
export const getConferenceSignUpListPageAndSumAmount = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceSignUpB/getConferenceSignUpListPageAndSumAmount',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取会议报名总价 B端 认证
export const getConferenceSignUpSumAmount = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceSignUpB/getConferenceSignUpSumAmount',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//导出会议报名列表分页 B端 认证
export const exportConferenceSignUpList = (reqParam) => {
    return new Promise((resolve, reject) => {
        exportExcelWithCallBack('/cas-member-manager/conferenceSignUpB/exportConferenceSignUpList', reqParam, 'ConferenceSignUpList.xlsx').then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取当前会议列表分页 B端 认证
export const getConferenceCurrentListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceB/getConferenceCurrentListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取当前会议列表 B端 认证
export const getConferenceCurrentBList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceB/getConferenceCurrentList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取当前会议详情 B端 认证
export const getConferenceCurrentBDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceB/getConferenceCurrentDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /conferenceAmountB/getConferenceAmountList
// 获取 会议费用 列表 B端 认证
export const getConferenceAmountList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceAmountB/getConferenceAmountList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 修改 当前会议 推送首页 B 认证
export const conferenceCurrentUpdateHome = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceB/conferenceCurrentUpdateHome',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 修改 当前会议(默认不推送首页) B 认证
export const conferenceCurrentUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceB/conferenceCurrentUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 新增 当前会议 B 认证
export const conferenceCurrentAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceB/conferenceCurrentAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceB/conferenceCurrentTransHistory
// 修改 当前会议转为历史 B 认证
export const conferenceCurrentTransHistory = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceB/conferenceCurrentTransHistory',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

//GET /conferenceAmountB/getConferenceAmountDetail
// 获取 会议费用 列表 B端 认证
export const getConferenceAmountDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceAmountB/getConferenceAmountDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// //POST 修改 会议费用(注意根据会议费用id修改 无会议id) B 认证
export const conferenceAmountUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceAmountB/conferenceAmountUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceB/conferenceCurrentTransHistory
// 修改 当前会议转为历史 B 认证
export const conferenceAmountDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceAmountB/conferenceAmountDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceB/conferenceCurrentTransHistory
// 修改 当前会议转为历史 B 认证
export const conferenceAmountAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceAmountB/conferenceAmountAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /conferenceSessionB/getConferenceSessionList
// 获取 会议主题 列表 B端 认证
export const getConferenceSessionList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceSessionB/getConferenceSessionList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /conferenceSessionB/getConferenceSessionDetail
// 获取 会议主题详情 B端 认证
export const getConferenceSessionDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceSessionB/getConferenceSessionDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceSessionB/conferenceSessionAdd
// 新增 会议主题 B 认证
export const conferenceSessionAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceSessionB/conferenceSessionAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
///conferenceSessionB/conferenceSessionUpdate
// 修改 会议主题(注意根据会议主题id修改 无会议id) B 认证
export const conferenceSessionUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceSessionB/conferenceSessionUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// /conferenceSessionB/conferenceSessionDel
// 删除 会议主题 B 认证
export const conferenceSessionDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceSessionB/conferenceSessionDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /conferenceHistoryB/getConferenceHistoryListPage
// 获取历史会议列表分页 B端 认证
export const getConferenceHistoryListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceHistoryB/getConferenceHistoryListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /conferenceHistoryB/getConferenceHistoryList
// 获取历史会议列表 B端 认证
export const getConferenceHistoryList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceHistoryB/getConferenceHistoryList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /conferenceHistoryB/getConferenceHistoryDetail
// 获取 会议历史详情 B端 认证
export const getConferenceHistoryDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceHistoryB/getConferenceHistoryDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
///conferenceHistoryB/conferenceHistoryAdd
// 新增 历史会议 B 认证
export const conferenceHistoryAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceHistoryB/conferenceHistoryAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceHistoryB/conferenceHistoryDel
// 删除 历史会议 B 认证
export const conferenceHistoryDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceHistoryB/conferenceHistoryDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /conferenceHistoryB/conferenceHistoryUpdate
// 修改 历史会议 B 认证
export const conferenceHistoryUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceHistoryB/conferenceHistoryUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /journalB/getJournalList
// 获取 期刊列表 （按照 更新时间倒排）B端 认证
export const getJournalList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalB/getJournalList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /journalB/getJournalDetail
// 获取 期刊详情 B端 认证
export const getJournalDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalB/getJournalDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /journalB/getJournalListPage
// 获取 期刊 列表分页（按照 更新时间倒排） B端 认证
export const getJournalListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalB/getJournalListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /journalB/journalAdd
// 新增 期刊 B 认证
export const journalAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/journalB/journalAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /journalB/journalDel
// 删除 期刊 B 认证
export const journalDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/journalB/journalDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /journalB/journalUpdate
// 修改 期刊 B 认证
export const journalUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/journalB/journalUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /bookB/bookAdd
// 新增 出版物 B 认证
export const bookAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/bookB/bookAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /bookB/bookDel
// 删除 出版物 B 认证
export const bookDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/bookB/bookDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /bookB/bookUpdate
// 修改 出版物 B 认证
export const bookUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/bookB/bookUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /bookB/getBookDetail
// 获取 出版物 B端 认证
export const getBookDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookB/getBookDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /bookB/getBookList
// 获取 出版物 （按照 更新时间倒排）B端 认证
export const getBookList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookB/getBookList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /bookB/getBookListPage
// 获取 出版物 列表分页（按照 更新时间倒排） B端 认证
export const getBookListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookB/getBookListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /branchB/branchAdd
// 新增 分会 B 认证
export const branchAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/branchB/branchAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /branchB/branchDel
// 删除 分会 B 认证
export const branchDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/branchB/branchDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /branchB/branchUpdate
// 修改 分会 B 认证
export const branchUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/branchB/branchUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /branchB/branchUpdateOrder
// 修改 分会 排序 B 认证
export const branchUpdateOrder = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/branchB/branchUpdateOrder',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /branchB/getBranchDetail
// 获取 分会 B端 认证
export const getBranchDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/branchB/getBranchDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /branchB/getBranchList
// 获取 分会 （按照 更新时间倒排）B端 认证
export const getBranchList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/branchB/getBranchList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /branchB/getBranchListPage
// 获取 分会 列表分页（按照 先按照ordernum正序排null的在最后，在按照更新时间倒序排 更新时间倒排） B端 认证
export const getBranchListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/branchB/getBranchListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /newsB/getNewsDetail
// 获取 新闻详情 B端 认证
export const getNewsDetail = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsB/getNewsDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /newsB/getNewsList
// 获取 新闻列表 B端 认证
export const getNewsList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsB/getNewsList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /newsB/getNewsListPage
// 获取 新闻 列表分页（注意 搜索时间字段是 内容更新时间） B端 认证
export const getNewsListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsB/getNewsListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /newsB/newsAdd
// 新增 新闻 B 认证
export const newsAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/newsB/newsAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /newsB/newsDel
// （1219删除封装）删除 新闻 B 认证
export const newsDel = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/newsB/newsDel',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /newsB/newsUpdate
// 修改 新闻 B 认证
export const newsUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/newsB/newsUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /newsB/newsUpdateHome
// 修改 新闻 是否首页推送：最多三条 B 认证
export const newsUpdateHome = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/newsB/newsUpdateHome',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /aboutusConfigB/getAboutusConfigByType
// 获取会员权益 B端 认证: 10：mission、20：constitution、30：board、40：code of ethics、50：awards
export const getAboutusConfigByType = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/aboutusConfigB/getAboutusConfigByType',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /aboutusConfigB/saveOrUpdateAboutusConfigByType
// 获取会员权益 B端 认证: 10：mission、20：constitution、30：board、40：code of ethics、50：awards
export const saveOrUpdateAboutusConfigByType = (data) => {
    return new Promise((resolve, reject) => {
        http.post('/cas-member-manager/aboutusConfigB/saveOrUpdateAboutusConfigByType', data, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /newsC/getNewsDetail
// 获取 新闻详情 C端 非认证
export const getNewsDetailC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsC/getNewsDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /newsC/getNewsHomeList
// 获取 新闻 列表首页列表（注意 limit由后端通知） C端 非认证
export const getNewsHomeListC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsC/getNewsHomeList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /newsC/getNewsListPage
// 获取 新闻 列表分页（isTimeDesc：默认是true; 排除首页的3个id，请将首页已展示的id传入。C端 非认证
export const getNewsListPageC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/newsC/getNewsListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /newsC/newsRead
// 新增 新闻 C 非认证
export const newsRead = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/newsC/newsRead',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /aboutusConfigC/getAboutusConfigByType
// 获取关于我配置信息： C端 非认证 10：mission、20：constitution、30：board、40：code of ethics、50：awards
export const getAboutusConfigByTypeC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/aboutusConfigC/getAboutusConfigByType',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /journalC/getJournalDetail
// 获取 期刊详情 B端 认证
export const getJournalDetailC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalC/getJournalDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /journalC/getJournalList
// 获取 期刊列表 （按照 更新时间倒排）B端 认证
export const getJournalListC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalC/getJournalList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /journalC/getJournalListPage
// 获取 期刊 列表分页（按照 更新时间倒排） B端 认证
export const getJournalListPageC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/journalC/getJournalListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /bookC/getBookDetail
// 获取 出版物 B端 认证
export const getBookDetailC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookC/getBookDetail',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /bookC/getBookList
// 获取 出版物 （按照 更新时间倒排）B端 认证
export const getBookListC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookC/getBookList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /bookC/getBookListPage
// 获取 出版物 列表分页（按照 更新时间倒排） B端 认证
export const getBookListPageC = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/bookC/getBookListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /conference/getConferenceHistroyList
// 获取历史会议列表(根据更新时间倒序) C端已登录用户+游客共用接口 根据更新时间倒序排序
export const getConferenceHistroyList = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conference/getConferenceHistroyList',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//GET /userB/getCurrentUserInfo
// 获取当前用户 信息（根据token） B端认证
export const getCurrentBUserInfo = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/userB/getCurrentUserInfo',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /userB/getUserInfo
// 获取用户 信息 B端认证
export const getUserInfo = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/userB/getUserInfo',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// GET /userB/getUserListPage
// 获取用户列表分页 B端认证
export const getUserListPage = (data) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/userB/getUserListPage',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /userB/userAdd
// 新增 B端账号 认证
export const userAdd = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/userB/userAdd',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// POST /userB/updateUserIsActive
// 用户禁用/启用修改,并让被修改用户退出登录：已登录 B端认证
export const updateUserIsActive = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/userB/updateUserIsActive',data,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
//POST /userB/userUpdate
// 修改 B端账号（修改任何人的，非当前的） 认证
export const userUpdate = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/userB/userUpdate',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 获取会员账单PDF C端认证
 */
export const getMemberInvoice = (data) => {
  return apiCall(http.get, '/cas-member-manager/memberC/getMemberInvoice', data, {
    isFormData: true,
    isBlob: true
  })
}

/**
 * 获取会员凭证PDF C端认证
 */
export const getMemberCertificate = (data) => {
  return apiCall(http.get, '/cas-member-manager/memberC/getMemberCertificate', data, {
    isFormData: true,
    isBlob: true
  })
}

/**
 * 会议附加内容相关接口
 */

// 批量保存会议附加内容 B端 认证
export const batchSaveAdditionalContents = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAdditionalContentB/batchSave', data, {
    isLoading: true
  })
}

// 初始化固定必填项 B端 认证
export const initRequiredContents = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAdditionalContentB/initRequiredContents', data, {
    isFormData: true
  })
}

// 新增单个附加内容 B端 认证
export const addAdditionalContent = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAdditionalContentB/addContent', data, {
    isLoading: true
  })
}

// 更新单个附加内容 B端 认证
export const updateAdditionalContent = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAdditionalContentB/updateContent', data, {
    isLoading: true
  })
}

// 删除单个附加内容 B端 认证
export const deleteAdditionalContent = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAdditionalContentB/deleteContent', data, {
    isFormData: true
  })
}

// 获取会议附加内容列表 B端 认证
export const getAdditionalContentsByConferenceId = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceAdditionalContentB/getContentsByConferenceId', data, {
    isFormData: true
  })
}

// 获取单个附加内容详情 B端 认证
export const getAdditionalContentDetail = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceAdditionalContentB/getContentDetail', data, {
    isFormData: true
  })
}

// 检查固定必填项是否已初始化 B端 认证
export const checkRequiredContentsExists = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceAdditionalContentB/checkRequiredContentsExists', data, {
    isFormData: true
  })
}

/**
 * 会议费用设置优化接口
 */

// 批量设置会议费用 B端 认证
export const conferenceAmountBatchSet = (data) => {
  return apiCall(http.post, '/cas-member-manager/conferenceAmountB/conferenceAmountBatchSet', data, {
    isLoading: true
  })
}

// 获取简化会议费用列表 B端 认证
export const getConferenceAmountSimpleList = (data) => {
  return apiCall(http.get, '/cas-member-manager/conferenceAmountB/getConferenceAmountSimpleList', data, {
    isFormData: true
  })
}

/**
 * 论文投稿相关接口
 */

// C端：保存论文信息到报名表
export const savePaperInfo = (registrationId, data) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceRegistrationC/savePaperInfo?registrationId=${registrationId}`,data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：提交论文（旧接口，已废弃）
export const submitPaper = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/paper/submit',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取我的论文列表
export const getMyPaperList = () => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/paper/list',{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取论文详情
export const getPaperDetail = (paperId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/paper/detail/${paperId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：修改论文
export const modifyPaper = (data) => {
    return new Promise((resolve,reject) => {
        http.put('/cas-member-manager/paper/modify',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取论文列表（带筛选）
export const getPaperListForAdmin = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/paperB/list',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取论文详情
export const getPaperDetailForAdmin = (paperId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/paperB/detail/${paperId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：审核论文
export const reviewPaper = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/paperB/review',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：批量设置论文费用
export const batchSetPaperAmount = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/paperAmountB/batchSet',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取论文费用列表
export const getPaperAmountList = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/paperAmountB/getList',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：检查论文费用设置是否完整
export const checkPaperAmountComplete = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/paperAmountB/checkComplete',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 会议参会报名V2接口 (V2版本)
 */

// C端：创建报名
export const createConferenceRegistration = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceRegistrationC/create',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：更新报名（提交前可修改）
export const updateRegistration = (registrationId, data) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceRegistrationC/update?registrationId=${registrationId}`,data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：完善个人信息
export const completePersonalInfo = (registrationId, data) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceRegistrationC/completePersonalInfo?registrationId=${registrationId}`,data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取报名详情
export const getRegistrationDetail = (registrationId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/conferenceRegistrationC/detail?registrationId=${registrationId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取我的报名列表
export const getMyRegistrationList = (email) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/conferenceRegistrationC/myList?email=${email}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：提交报名
export const submitRegistration = (registrationId) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceRegistrationC/submit?registrationId=${registrationId}`,{},false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：上传支付证明
export const uploadPaymentProof = (registrationId, data) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceRegistrationC/uploadPaymentProof?registrationId=${registrationId}`,data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：批量设置费用V2
export const batchSetConferenceAmountV2 = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceAmountV2B/batchSet',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取费用列表V2
export const getConferenceAmountListV2 = (conferenceId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/conferenceAmountV2B/getList?conferenceId=${conferenceId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取当前应缴费用
export const getCurrentAmount = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceAmountV2B/getCurrentAmount',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：检查费用设置完整性
export const checkAmountComplete = (conferenceId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/conferenceAmountV2B/checkComplete?conferenceId=${conferenceId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * V3 Reviewer Management APIs (B-end)
 * ============================================================================
 */

// B端：获取审稿人列表
export const getReviewerList = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceReviewerB/list',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：设置审稿人
export const setReviewer = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerB/set',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：移除审稿人
export const removeReviewer = (data) => {
    return new Promise((resolve,reject) => {
        http.post(`/cas-member-manager/conferenceReviewerB/remove?reviewerId=${data.reviewerId}`,{},false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * V3 Paper Review APIs (B-end)
 * ============================================================================
 */

// B端：获取待处理论文列表
export const getPendingPaperList = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceReviewerB/pendingPapers',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取待管理员确认的报名列表（状态5和6）
export const getPendingConfirmationList = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceRegistrationB/pendingConfirmationList',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：分配审稿人
export const assignReviewer = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerB/assign',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：直接同意/拒绝论文
export const directDecidePaper = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerB/directDecide',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：确认审稿结果
export const confirmReviewResult = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerB/confirmResult',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：变更审稿人（重新分配）
export const reassignReviewer = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerB/reassign',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * V3 Reviewer Center APIs (C-end)
 * ============================================================================
 */

// C端：获取我的待审论文列表
export const getMyPendingReviews = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceReviewerC/myPendingReviews',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：放弃审稿
export const abandonReview = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerC/abandonReview',data,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取我的已审论文列表（历史）
export const getMyReviewHistory = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceReviewerC/myReviewHistory',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：获取论文审稿详情
export const getReviewPaperDetail = (reviewId) => {
    return new Promise((resolve,reject) => {
        http.get(`/cas-member-manager/conferenceReviewerC/paperDetail?reviewId=${reviewId}`,{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：提交审稿结果
export const submitReviewResult = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceReviewerC/submitReview',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：检查是否是审稿人
export const checkIsReviewer = () => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/conferenceReviewerC/checkReviewer',{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * Order Management APIs (B-end)
 * ============================================================================
 */

// B端：获取订单列表
export const getOrderList = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/orderB/getOrderList',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取订单详情
export const getOrderDetail = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/orderB/getOrderDetail',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取订单统计
export const getOrderStatistics = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/orderB/getOrderStatistics',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * Email Config APIs (B-end)
 * ============================================================================
 */

// B端：获取邮件配置列表
export const getEmailConfigList = () => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/emailConfigB/list',{},true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取邮件配置详情
export const getEmailConfigDetail = (params) => {
    return new Promise((resolve,reject) => {
        http.get('/cas-member-manager/emailConfigB/detail',params,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：保存邮件配置
export const saveEmailConfig = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/emailConfigB/save',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：预览邮件效果
export const previewEmail = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/emailConfigB/preview',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：发送测试邮件
export const sendTestEmail = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/emailConfigB/sendTest',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取待审核支付证明列表 - 使用统一 list 接口
// 查询状态7且有支付证明的记录
export const getPendingPaymentReviewList = (conferenceId) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/list', {
            conferenceId: conferenceId,
            registrationStatus: 7,
            hasPaymentProof: true
        }, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：审核通过支付证明
export const approvePayment = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/approvePayment',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：审核拒绝支付证明
export const rejectPayment = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/rejectPayment',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取报名列表（统一接口，支持状态筛选）- POST /list
// RequestBody: { conferenceId, registrationStatus, registrationStatusList, hasPaymentProof, ... }
export const getRegistrationList = (data) => {
    return new Promise((resolve,reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/list',data,false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：导出会议总结 - POST /export
// RequestBody: @RequestBody RegistrationListQueryVo queryVo
// Response: blob (Excel file)
export const exportSummary = (data, fileName = 'ConferenceSummary.xlsx') => {
    return new Promise((resolve, reject) => {
        // 参数: url, data, isFormData=false, isLoading=true, needXss=true, ifMultipart=false, isBlob=true
        http.post('/cas-member-manager/conferenceRegistrationB/export', data, false, true, true, false, true).then(result => {
            // result 是 blob 数据
            const blob = result;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            resolve({ success: true });
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * Student Identity Verification APIs (学生身份审核)
 * ============================================================================
 */

// C端：上传学生证明文件
export const uploadStudentProof = (data) => {
    return new Promise((resolve, reject) => {
        http.post('/cas-member-manager/conferenceRegistrationC/uploadStudentProof', data, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// C端：重新提交学生证明（审核拒绝后）- 复用 uploadStudentProof
export const resubmitStudentProof = (data) => {
    return uploadStudentProof(data);
}

// B端：审核学生身份
export const verifyStudentIdentity = (data) => {
    return new Promise((resolve, reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/verifyStudentIdentity', data, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// B端：获取待审核学生身份列表
export const getPendingStudentIdList = (params) => {
    return new Promise((resolve, reject) => {
        http.get('/cas-member-manager/conferenceRegistrationB/getPendingStudentIdList', params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * ============================================================================
 * Admin Registration Management APIs (管理员报名信息管理)
 * ============================================================================
 */

// B端：管理员修改报名信息（报告类型等）
export const adminUpdateRegistration = (data) => {
    return new Promise((resolve, reject) => {
        http.post('/cas-member-manager/conferenceRegistrationB/adminUpdate', data, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
